import { HttpClientService } from "../service/http-client.service.ts";
import { Observable } from "rxjs";
import { WishlistNameModel } from "../model/wishlist/wishlist-name.model.ts";

export class WishlistRepo {
  protected static getEndpointUrl(): string {
    return "/user";
  }

  static getNewWishlistName(): Observable<WishlistNameModel> {
    return HttpClientService.get(
      `${this.getEndpointUrl()}/wishlists/cart-name`,
    );
  }

  static saveNewWishlist(): Observable<string> {
    return HttpClientService.post(
      `${this.getEndpointUrl()}/my-shop/wishlist/cart`,
      "",
    );
  }
}
